module.exports = __webpack_public_path__ + "static/media/timer.4151b98e.png";